<template>
  <div>
    <span>{{ time.slice(0, 10) }}</span>
    <br />
    <span>{{ time.slice(10) }}</span>
  </div>
</template>

<script>
export default {
  name: 'Time2Line',
  props: {
    time: {
      type: String,
      default: '',
    },
  },
};
</script>
